<template>
  <div class="q-pb-sm layout-padding">
    <q-field class="q-pa-md">
      <h5 style="margin-bottom:20px"><q-icon name="fa fa-edit" color="primary" /> User Notes</h5>
      <q-input
        inverted-light
        color="grey-12"
        rows="7"
        type="textarea"
        :max-height="100"
        :value="userForm.USER_NOTES"
        @keyup.stop="updateUserForm({ field: 'USER_NOTES', value: $event.target.value })"
      />
    </q-field>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'UserNotes',
  data () {
    return {
      userForm: this.$store.state.users.userForm
    }
  },
  methods: {
    ...mapMutations('users', [
      'updateUserForm'
    ])
  }
}
</script>

<style>
</style>
